/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function TassatPayLogoAndName(props: CustomSvgIcon) {
    const {
        id,
        className,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
            viewBox='0 0 446.39 90.88'
        >
            <svg
                data-name='Layer 1'
                viewBox='0 0 446.39 90.88'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M106.15,73.39V17.68H85.54V10.27h49.58v7.41H114.43V73.39Z'
                    fill='#00427a'
                />
                <path
                    d='M149.86,72.35a38.1,38.1,0,0,1-.86-6.81c-2.16,5.09-7,7.85-13.89,7.85-9,0-14.48-5.35-14.48-13,0-8.94,7.41-14.94,20.43-14.94h7.51V40.19c0-4.66-2.85-7.07-8.54-7.07-5.35,0-8.62,2.76-8.8,7.41h-7.67v-.69c0-7.58,5.61-11.81,15.95-11.81,12.33,0,17.08,4.31,17.08,13.45V68.21a28.77,28.77,0,0,0,.43,4.14Zm-8-21.47c-8.71,0-13,3.54-13,8.71,0,4.14,3.36,7.33,8.19,7.33,7.42,0,11.56-4,11.56-11.73V50.88Z'
                    fill='#00427a'
                />
                <path
                    d='M169.37,59.33v.17c0,4.75,3.62,7.85,9.14,7.85s9.05-2.84,9.05-6.81c0-3-1.64-4.83-5.17-5.69l-9.23-2.16c-7.67-1.81-11.46-5.52-11.46-11.29,0-7.59,6.63-13.28,17.5-13.28,9.83,0,15.69,4.4,15.69,11.38a7.91,7.91,0,0,1-.08,1.29h-7.94v-.34c0-4.23-3.19-6.73-8.27-6.73S170,36.57,170,40c0,2.84,1.9,4.39,6.38,5.6l9.83,2.67c6.73,1.82,10,5.52,10,11.65,0,8-6.47,13.45-17.34,13.45-12,0-17.5-4-17.5-13v-1Z'
                    fill='#00427a'
                />
                <path
                    d='M207.37,59.33v.17c0,4.75,3.62,7.85,9.14,7.85s9.06-2.84,9.06-6.81c0-3-1.64-4.83-5.18-5.69l-9.22-2.16c-7.68-1.81-11.47-5.52-11.47-11.29,0-7.59,6.64-13.28,17.5-13.28,9.83,0,15.69,4.4,15.69,11.38a7.91,7.91,0,0,1-.08,1.29h-7.93v-.34c0-4.23-3.19-6.73-8.28-6.73S208,36.57,208,40c0,2.84,1.89,4.39,6.38,5.6l9.83,2.67c6.72,1.82,10,5.52,10,11.65,0,8-6.47,13.45-17.33,13.45-12,0-17.51-4-17.51-13v-1Z'
                    fill='#00427a'
                />
                <path
                    d='M266.63,72.35a37.23,37.23,0,0,1-.87-6.81c-2.15,5.09-7,7.85-13.88,7.85-9,0-14.48-5.35-14.48-13,0-8.94,7.41-14.94,20.43-14.94h7.54V40.19c0-4.66-2.84-7.07-8.53-7.07-5.35,0-8.63,2.76-8.8,7.41h-7.67v-.69c0-7.58,5.6-11.81,15.95-11.81,12.29,0,17.05,4.31,17.05,13.42V68.21a30.26,30.26,0,0,0,.43,4.14Zm-8-21.47c-8.71,0-13,3.54-13,8.71,0,4.14,3.36,7.33,8.19,7.33,7.41,0,11.55-4,11.55-11.73V50.88Z'
                    fill='#00427a'
                />
                <path
                    d='M282.77,29.07V20.19l7.94-2.68V29.07h9.66v5.69h-9.65V61.31c0,4.32.94,5.52,5.51,5.52a15.13,15.13,0,0,0,4-.6v6a25.33,25.33,0,0,1-6.29,1c-7.76,0-11.13-2.24-11.13-9.14V34.76h-7.33V29.07Z'
                    fill='#00427a'
                />
                <path
                    d='M58.15,73.39h0C62.89,71.14,62.38,63.13,57,55.5L32.59,20.71C27.86,23,28.37,31,33.72,38.6Z'
                    fill='#00427a'
                />
                <path
                    d='M38.57,73.39h0c-4.73-2.25-4.2-10.26,1.14-17.89L64.14,20.71C68.87,23,68.37,31,63,38.6Z'
                    fill='#0066b2'
                />
                <path
                    d='M51.7,3.25h0A7.64,7.64,0,0,0,41.9,6L32.56,20.7A7.64,7.64,0,0,0,42.37,18Z'
                    fill='#0066b2'
                />
                <path
                    d='M45,3.25h0A7.65,7.65,0,0,1,54.8,6L64.15,20.7A7.64,7.64,0,0,1,54.37,18Z'
                    fill='#00427a'
                />
                <path
                    d='M15.7,73a9.7,9.7,0,0,0,2.63.36H38.56c0-5.06-3.71-8-8.19-8H10.63Z'
                    fill='#00427a'
                />
                <path
                    d='M24.06,33,9.45,53.79a10.3,10.3,0,0,0-2.08,6.59l3.26,5L25.3,44.61C28.51,40.06,28,34.87,24.06,33Z'
                    fill='#0066b2'
                />
                <path
                    d='M81,73a9.81,9.81,0,0,1-2.63.36H58.14c0-5.06,3.7-8,8.19-8H86.07Z'
                    fill='#0066b2'
                />
                <path
                    d='M72.64,33,87.25,53.79a10.42,10.42,0,0,1,2.06,6.59l-3.26,5L71.37,44.61C68.19,40.06,68.75,34.87,72.64,33Z'
                    fill='#00427a'
                />
                <path
                    d='M308.46,9.75h22q20.6,0,20.59,17.35,0,9.65-6.13,13.85t-18.58,4.2h-9.47v27.7h-8.41Zm20.6,27.6c4.49,0,7.8-.74,9.9-2.23s3.15-4.1,3.15-7.84-1-6.53-3.11-8S333.61,17,329.06,17H316.87V37.35Z'
                    fill='#00427a'
                />
                <path
                    d='M405.49,71.85l-18-44h8.23l14,34.88L424,27.85H432L406.28,88.5h-7.54Z'
                    fill='#00427a'
                />
                <path
                    d='M379.13,72.35a37.23,37.23,0,0,1-.87-6.81c-2.15,5.09-7,7.85-13.88,7.85-9,0-14.48-5.35-14.48-13,0-8.94,7.41-14.94,20.43-14.94h7.54V40.19c0-4.66-2.84-7.07-8.53-7.07-5.35,0-8.63,2.76-8.8,7.41h-7.67v-.69c0-7.58,5.6-11.81,15.95-11.81,12.29,0,17.05,4.31,17.05,13.42V68.21a30.26,30.26,0,0,0,.43,4.14Zm-8-21.47c-8.71,0-13,3.54-13,8.71,0,4.14,3.36,7.33,8.19,7.33,7.41,0,11.55-4,11.55-11.73V50.88Z'
                    fill='#00427a'
                />
            </svg>
        </SvgIcon>
    );
}